module.exports = __webpack_public_path__ + "878f4e02fa59a26009b81c62ac616a3b.png";